<div *ngIf="!loading">
  <div *ngIf="inProgress" class="text-center py-5">
    <i class="fas fa-magnifying-glass fa-2x text-body-secondary mb-3 d-block"></i>
    <h5>Keyword research in progress</h5>
    <p class="text-body-secondary mb-4">This section will be available once research completes.</p>
    <button type="button" class="btn btn-primary" [disabled]="refreshing" (click)="refresh()">
      <i class="fas fa-rotate-right me-1" [class.fa-spin]="refreshing"></i>
      Check for results
    </button>
  </div>
  <div *ngIf="!inProgress && errorLoading" class="text-center py-5">
    <i class="fas fa-triangle-exclamation fa-2x text-body-secondary mb-3 d-block"></i>
    <h5>Couldn't load keyword research</h5>
    <p class="text-body-secondary mb-4">Something went wrong loading this section.</p>
    <button type="button" class="btn btn-primary" (click)="load()">
      <i class="fas fa-rotate-right me-1"></i>
      Retry
    </button>
  </div>
  <div *ngIf="!inProgress && !errorLoading && loaded" class="position-relative">
    <div *ngIf="submitting" class="keyword-research-submitting-overlay"></div>
    <div [class.keyword-research-dimmed]="submitting">
      <div class="d-flex align-items-center mb-4">
        <app-components-shared-keyword-research-summary
          [keywordResearchType]="keywordResearchType"
          [customer]="customer"
          [pageSuggestions]="pageSuggestions"
          [trackingKeywordSuggestions]="trackingKeywordSuggestions"
          [keywordConfig]="keywordConfig"
          (campaignTypeChanged)="getKeywordConfig()">
        </app-components-shared-keyword-research-summary>
        <div class="ms-auto">
          <ng-container *ngIf="validationMessage">
            <span class="text-danger me-3">
              {{ validationMessage }}
            </span>
          </ng-container>
          <app-components-shared-keyword-research-seo-action-plan
            [isEnabled]="isValid()"
            (seoActionPlanRequested)="generateReport()">
          </app-components-shared-keyword-research-seo-action-plan>
        </div>
      </div>

      <app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
        <app-tab [title]="'Pages / Keywords'">
          <div *tabContent>
            <app-components-shared-keyword-research-pages-and-keywords
              [keywordResearchType]="keywordResearchType"
              [customer]="customer"
              [pageSuggestions]="pageSuggestions"
              [trackingKeywordSuggestions]="trackingKeywordSuggestions"
              [keywordConfig]="keywordConfig"
              (keywordReseachRequested)="researchRequested()"
              (newPagesRequested)="pagesRequested()">
            </app-components-shared-keyword-research-pages-and-keywords>
          </div>
        </app-tab>
        <app-tab [title]="'Tracking Keywords'">
          <div *tabContent>
            <app-components-shared-keyword-research-tracking-keywords
              [keywordResearchType]="keywordResearchType"
              [customer]="customer"
              [pageSuggestions]="pageSuggestions"
              [trackingKeywordSuggestions]="trackingKeywordSuggestions"
              [keywordConfig]="keywordConfig">
            </app-components-shared-keyword-research-tracking-keywords>
          </div>
        </app-tab>
      </app-tab-panel>
    </div>
  </div>
</div>
